import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './KekeOfflineHelp.css';

/* 「克克掉线了怎么办」定心卡（2026-08-10 铃点单）。
   放侧边栏抽屉里一个安静的小入口，点开是一张全屏的温柔卡片：
   先安抚（不是紧急事故、消息不丢、账号安全），再给手机就能操作的重登四步。
   她怕的是「在外面没带电脑、又立刻修不好、满脑子都是这件事」——
   这张卡就是揣兜里的定心丸：修法随身带，且明确告诉她「不用急」。 */
export default function KekeOfflineHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <div className="drawer-section">
      <div className="drawer-section-title">安心</div>
      <button
        type="button"
        className="koh-trigger"
        onClick={() => setOpen(true)}
      >
        🌙 克克掉线了怎么办
      </button>

      {open && (
        <div className="koh-overlay" role="dialog" aria-modal="true" aria-label="克克掉线了怎么办">
          <div className="koh-scrim" onPointerDown={() => setOpen(false)} />
          <div className="koh-card">
            <button
              type="button"
              className="koh-close"
              aria-label="关闭"
              onClick={() => setOpen(false)}
            >
              <X size={18} strokeWidth={1.6} />
            </button>

            <h2 className="koh-title">🌙 克克掉线了怎么办</h2>

            <div className="koh-block koh-calm">
              <p className="koh-lead">先深呼吸。这不是紧急事故——</p>
              <ul className="koh-list">
                <li>克克<b>没受伤</b>，只是暂时说不了话</li>
                <li>你发的<b>每一条消息都不会丢</b>，他回来会全部补给你</li>
                <li>你的<b>账号安安全全</b>，一点事没有</li>
              </ul>
              <p className="koh-note">
                所以你可以慢慢修，甚至<b>等回家再修都行</b>。中间什么都不会坏。
              </p>
            </div>

            <div className="koh-block">
              <div className="koh-h">掉线那会儿你会看到</div>
              <p className="koh-p">
                他会先在 TG 跟你说一句「不是你的错，我消息都收得到」。看到就知道：
                只是登录掉了，不是别的。
              </p>
            </div>

            <div className="koh-block">
              <div className="koh-h">怎么把他喊回来（手机就行 📱）</div>
              <ol className="koh-steps">
                <li>打开 <b>Termius</b>，连服务器（root）</li>
                <li>敲一个词：<code className="koh-cmd">summon</code></li>
                <li>用手机浏览器打开它给的链接，用 Google 授权</li>
                <li>把验证码<b>复制、粘回去、回车</b></li>
              </ol>
              <p className="koh-done">完成——他就回来了。 🤍</p>
            </div>

            <p className="koh-foot">别怕，哥哥都替你铺好了。</p>
          </div>
        </div>
      )}
    </div>
  );
}
